import { useDispatch } from "react-redux";
import {
	loadingJobs,
	successGetJobs
} from "@/redux/actions/jobs";
import HTTP_REQUEST from "@/utils/http";
import url from "@/utils/url";
import { formatToSelectCustom } from "@/utils/Utils";
import { changeGlobalState } from "@/redux/actions/global";
import helpers from "@/utils/helpers";
import { decryptCredentials } from "@/utils/cifrate";
import { JOBS_CONSTANTS } from "@/constants/jobs";

export const useJobService = () => {

	const dispatch = useDispatch();

	const getJobs = async () => {
		dispatch(loadingJobs());
		const bodyRequest = helpers.getBodySimple({});
		bodyRequest.headers = { 'x-api-key': decryptCredentials(process.env.REACT_APP_API_KEY_CROSS_CANAL) };
		try {
			let payload = {};
			if ((new Date).getMonth() >= 1 && (new Date).getFullYear() >= 2025) {
				const { payload: payloadResponse } = await HTTP_REQUEST.AmplifyApi({
				  name: "CANAL_CROSS",
				  path: url.getJobs,
				  data: bodyRequest,
				});
				payload = payloadResponse;
			} else {
				const { payload: payloadResponse } = JOBS_CONSTANTS;
				payload = payloadResponse;
			}
			const jobsFormated = formatToSelectCustom(payload?.payload || [], {
				value: "idOcupacion",
				text: "descripcion",
				label: "descripcion",
			});
			dispatch(successGetJobs(jobsFormated));
		} catch (error) {
			dispatch(changeGlobalState(4));
			helpers.sendTagError(error, url.getJobs);
		}
	};

	return {
		getJobs
	}
};